import userService from "./userService";

export const logoutUser = () => {
    userService.logout();
    window.location.href = "/login";
};
